import * as React from "react";

import RestaurantStore from "./store";

type RestaurantStoreProviderProps = {
  runtimeModel: { name: string };
  children?: React.ReactNode;
};

/** Easy Peasy — inferred Provider output widened under React 19; narrow for valid React tree. */
const RestaurantStoreProvider =
  RestaurantStore.Provider as React.ComponentType<RestaurantStoreProviderProps>;

type WithContextRestaurantStoreProps = NonNullable<unknown>;

export default function withRestaurantStore<
  T extends WithContextRestaurantStoreProps = WithContextRestaurantStoreProps,
>(WrappedComponent: React.ComponentType<T>, name: string) {
  const ComponentWithStore = (props: T) =>
    React.createElement(
      RestaurantStoreProvider,
      { runtimeModel: { name } },
      React.createElement(WrappedComponent, props),
    );

  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";

  ComponentWithStore.displayName = `withRestaurantStore(${displayName})`;

  return ComponentWithStore;
}
